/* Полоса «Файл» — орган ЭКРАНА, а не превью, и стоит снаружи `.tgzone`, как полоса визуала:
   фирменные токены здесь и делают видимой границу «здесь кончается чужой клиент». Геометрия
   совпадает с `VisualStrip.module.css` один в один: две полосы под постом отвечают на один
   вопрос — «что ещё уйдёт вместе с текстом», — и разная посадка читалась бы как разная природа.
   Ни одного цвета литералом (правило docs/frontend.md). */

.strip {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--r-card);
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 9px;
  min-width: 0;
}

/* Подсветка зоны сброса — атрибутом, как у колонки поста (`DraftPanel.module.css`). */
.strip[data-dropping] {
  outline: 2px dashed var(--violet);
  outline-offset: 4px;
}

.head {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}

.file {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  min-width: 0;
}

/* Значок и имя — одно целое: длинное имя на телефоне переносится ВНУТРИ группы, и значок
   остаётся у первой строки имени, а не висит один строкой выше (снимок 19.09.2026). */
.fileHead {
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
}

.fileIcon {
  display: inline-flex;
  color: var(--accent-ink);
  flex: none;
  margin-top: 1px;
}

/* Имя — то, что увидит читатель канала, до 128 знаков: переносится, а не режется — обрезанное
   имя здесь было бы не тем, которое утверждают. */
.fileName {
  font-size: 13px;
  font-weight: 600;
  color: var(--ink);
  overflow-wrap: anywhere;
  min-width: 0;
}

/* Строки хода, итога и отказа — «Загружаем «…» — N %», «Файл «…» прикреплён — сохранено как
   vN», «Это не PDF: у файла «…»…» — несут то же имя, до 128 знаков и нередко без единого
   пробела («Otchet_po_rynku_GEO_sentyabr_2026_final.pdf»). Они — пункты строчных флексов
   (`.progress`, `.val`), и без этих двух свойств их минимальная ширина — имя целиком: на 390px
   строка уезжала за рамку полосы, а `overflow-x: clip` страницы срезал проценты и «vN». */
.line {
  min-width: 0;
  overflow-wrap: anywhere;
}

.open {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12.5px;
  font-weight: 500;
  text-decoration: none;
}

.actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}

/* Ход загрузки: дорожка `--violet-bg`, заливка `--violet` — те же цвета, что у полосы хода
   прогона в шапке (`RunStatusBar.module.css`): «сколько прошли» на экране выглядит одинаково. */
.progress {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.track {
  position: relative;
  flex: 1 1 160px;
  height: 4px;
  border-radius: var(--r-pill);
  background: var(--violet-bg);
  overflow: hidden;
}

.fill {
  height: 100%;
  border-radius: var(--r-pill);
  background: var(--violet);
  transition: width 0.2s var(--ease);
}

/* Длина неизвестна или сервер собирает версию: треть дорожки ходит туда-обратно. Без
   анимации (`prefers-reduced-motion`) — стоит на месте: ход виден подписью рядом. */
.fillBusy {
  width: 33%;
  animation: docBusy 1.2s var(--ease) infinite alternate;
}

@keyframes docBusy {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(200%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .fill {
    transition: none;
  }
  .fillBusy {
    animation: none;
  }
}

.cancel {
  font-family: var(--sans);
  font-size: 12.5px;
  font-weight: 500;
  color: var(--accent-ink);
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

/* Баннер зоны сброса — только на перетаскивании, как у полосы визуала: постоянная пунктирная
   рамка читалась бы как незаполненное поле формы. */
.dropHint {
  border: 2px dashed var(--violet);
  background: var(--violet-bg);
  border-radius: var(--r-ctl);
  padding: 10px 12px;
  color: var(--accent-ink);
  font-size: 12.5px;
  font-weight: 600;
  text-align: center;
}
